// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.jsdelivr.net/npm/keen-slider@5.5.1/+esm'

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends window.BAO.CustomElement {
      constructor () {
        super()

        if (this.els.slide.elements.length < 2) return

        this.carousel = this.initialiseCarousel()

        this.lightboxCarousel = this.initialiseLightboxCarousel()

        this.els.slide.elements.forEach(el => {
          el.addEventListener('click', event => {
            this.lightboxOpen(el.dataset.slideIndex)
          })
        })

        document.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            this.lightboxClose()
          }
        })

        this.els.lightboxClose.element.addEventListener('click', () => {
          this.lightboxClose()
        })

        this.els.lightboxPrevious.element.addEventListener('click', () => {
          this.lightboxCarousel.prev()
        })

        this.els.lightboxNext.element.addEventListener('click', () => {
          this.lightboxCarousel.next()
        })

        this.activeVideo = null
      }

      lightboxClose () {
        this.els.lightbox.element.classList.remove(
          'sec-MediaGallery_Lightbox-open',
        )

        if (this.activeVideo) {
          this.activeVideo.pause()
        }
      }

      lightboxOpen (slideIndex) {
        this.els.lightbox.element.classList.toggle(
          'sec-MediaGallery_Lightbox-open',
        )

        if (slideIndex) {
          this.lightboxCarousel.moveToSlide(slideIndex, 0)
        }
      }

      initialiseCarousel () {
        if (this.els.slide.elements.length > 3) {
          this.els.slides.element.setAttribute(
            'data-custom-cursor-external-el',
            'carousel',
          )
        }

        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1.1,
          slides: '.car-Carousel_Slide',
          spacing: 15,
          breakpoints: {
            '(min-width: 768px)': {
              centered: true,
              controls: this.els.slide.elements.length > 3,
              loop: true,
              mode: 'snap',
              slidesPerView: 2.1,
              spacing: 30,
            },
            '(min-width: 901px)': {
              centered: true,
              controls: this.els.slide.elements.length > 3,
              loop: true,
              mode: 'snap',
              slidesPerView: 3.3,
              spacing: 30,
            },
          },
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide,
              )
            })
          },
        })
      }

      initialiseLightboxCarousel () {
        return new KeenSlider(this.els.lightboxSlides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1,
          slides: '.sec-Lightbox_Slide',
          loop: true,
          slideChanged: instance => {
            const slides = this.els.lightboxSlides.element.querySelectorAll(
              '.sec-Lightbox_Slide',
            )
            const slideIndex = instance.details().absoluteSlide % slides.length
            const slide = slides[slideIndex]

            if (this.activeVideo) {
              this.activeVideo.pause()
            }

            const video = slide.querySelector('.sec-Lightbox_Video')
            if (video) {
              this.activeVideo = video
            }
          },
        })
      }
    },
  )
}
